'use client'

import Image from 'next/image'

import Button from '@/components/ui/Button'
import { useConfigContext } from '@/context/ConfigProvider'
import { loadImage } from '@/lib/utils'
import { eGeneralInfo } from '@/types/enum'

export default function NotFound() {
  const { getBasic, locale } = useConfigContext()

  const text = (lang: string) => {
    if (lang === 'vi') {
      return {
        title: 'Đã có lỗi xảy ra',
        content: 'Rất tiếc. Trang bạn tìm kiếm không tồn tại!',
        btn: 'Về trang chủ',
      }
    } else {
      return {
        title: 'An error has occurred',
        content: 'Sorry. The page you are looking for does not exist!',
        btn: 'Back to home',
      }
    }
  }

  return (
    <div className="h-[50vh] flex items-center justify-center flex-col">
      <div className="w-[80%] lg:w-[20%]">
        <Image
          src={loadImage('large', +getBasic(eGeneralInfo.not_found_image)!)}
          alt="not found"
          width={0}
          height={0}
          sizes="100vw"
          className="w-[80%] grayscale mx-auto"
          unoptimized
        />
        <div className="text-center mt-3 space-y-1">
          <p className="text-xl font-bold text-black">{text(locale).title}</p>
          <p className="text-base text-gray">{text(locale).content}</p>
          <Button primary size="sm" className="mx-auto inline-flex mt-1" href="/">
            {text(locale).btn}
          </Button>
        </div>
      </div>
    </div>
  )
}
